import React, { useState, useEffect, useRef } from "react";
import ViewSignModal from "./ViewSignModal";
const PdfSignature = ({ page, inputId, value, onChange, e_sign, signerType = "" }) => {
  const [acknowledged, setAcknowledged] = useState(false);
  const [viewSignShowModal, setViewSignShowModal] = useState(false);
  const [eSignValue, setESignValue] = useState("");
  const canvasRef = useRef(null);
  useEffect(() => {
    if (e_sign !== "" && e_sign !== undefined && e_sign !== null) {
      setESignValue(e_sign);
    }
  }, [e_sign]);

  useEffect(() => {
    if (value === "Signature" || value === "[Signature]") {
      setAcknowledged(false);
    } else {
      setAcknowledged(value);
    }
  }, [value]);

  useEffect(() => {
    if (acknowledged && canvasRef.current) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      
      // Parse the signature data if it's a JSON string
      let signatureSrc = acknowledged;
      try {
        const parsed = typeof acknowledged === 'string' 
          ? JSON.parse(acknowledged) 
          : acknowledged;
        
        if (parsed.signature && parsed.signature.startsWith('data:image/')) {
          signatureSrc = parsed.signature;
        }
      } catch (e) {
        // If parsing fails, use the original acknowledged value
        signatureSrc = acknowledged;
      }
      
      const img = new Image();
      
      img.onload = () => {
        // Set canvas dimensions to match image
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
      };
      
      img.src = signatureSrc;
    }
  }, [acknowledged]);

  const ViewSignClick = () => {
    // If signerType is 'mine', don't open the modal
    if (signerType === "Mine") {
      return;
    }
    setViewSignShowModal(true);
  };

  const viewSignModalClose = () => {
    setViewSignShowModal(false);
  };

  const acknowledgedShow = (data) => {
    setAcknowledged(data);
    onChange(page, inputId, data);
  };

  return (
    <div className="signature-container">
      <div 
        className="pdf-signature" 
        onClick={() => ViewSignClick()}
        style={{ 
          cursor: signerType !== "Mine" ? "pointer" : "default" 
        }}
      >
        {(() => {
          // Check if we should show "(Signature)" based on signerType and signature data
          if (signerType === "Employee" || signerType === "" || signerType === null || signerType === undefined) {
            if (!acknowledged || acknowledged === "" || acknowledged === "Enter text..." || acknowledged === "Signature" || acknowledged === "[Signature]") {
              return "(Signature)";
            }
          }
          
          // Check if the signature contains actual image data
          let hasImageData = false;
          if (acknowledged && acknowledged !== "" && acknowledged !== "Enter text..." && acknowledged !== "Signature" && acknowledged !== "[Signature]") {
            try {
              const signatureData = typeof acknowledged === 'string' && acknowledged.startsWith("{")
                ? JSON.parse(acknowledged)
                : acknowledged;
              
              const signatureSrc = signatureData.signature || acknowledged;
              hasImageData = signatureSrc && signatureSrc.startsWith('data:image/');
            } catch (e) {
              // If parsing fails, check if the original value is an image
              hasImageData = acknowledged && acknowledged.startsWith('data:image/');
            }
          }
          
          // Show canvas only if we have actual image data
          if (hasImageData) {
            return (
              <canvas
                width="auto"
                height="40"
                ref={canvasRef}
              />
            );
          }
          
          // Default fallback - show "(Signature)" text
          return "(Signature)";
        })()}
      </div>
      {viewSignShowModal && (
        <ViewSignModal
          show={viewSignShowModal}
          handleClose={viewSignModalClose}
          acknowledgedShow={acknowledgedShow}
          eSign={eSignValue}
          value={acknowledged}
          employeePdf={true}
        />
      )}
    </div>
  );
};

export default PdfSignature;
